var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowNext = function SvgArrowNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    x: 0.5,
    y: 0.5,
    stroke: "url(#ArrowNext_svg__a)",
    rx: 16.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ArrowNext_svg__b)",
    d: "m15.998 22.249 5.208-5.109q.018-.017.037-.033a.85.85 0 0 0 0-1.218l-5.235-5.136a.89.89 0 0 0-1.241 0 .85.85 0 0 0 0 1.217l4.613 4.525-4.623 4.535a.85.85 0 0 0 0 1.217.89.89 0 0 0 1.241.002"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ArrowNext_svg__a",
    x1: 17,
    x2: 17,
    y1: 1,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAB105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2721B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ArrowNext_svg__b",
    x1: 21.5,
    x2: 14.5,
    y1: 16.5,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAB105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2721B"
  })))));
};
export default SvgArrowNext;